<template>
  <div class="sorter"
       @click.prevent="handleClick"
       @mouseenter.passive="handleMouseEnter"
       @mouseleave.passive="handleMouseLeave">
    <template v-if="active">
      <div class="filter-input filter-icon">
        <span>{{ title }}</span>
        <img :src="icon" alt="Icon">
      </div>
      <div class="field-dropdown with-scrollbar" :class="{open: openState}">
        <div class="list-item "
             v-for="(item, index) in children"
             :index="index"
             :key="item.id"
             @click.stop="handleClickChild(item)"
             :class="{active: isActive(item)}"
        >
          <div class="check-button"></div>
          <span class="name">{{ item.label }}</span>
        </div>
      </div>
    </template>

  </div>
</template>
<script>
export default {
  name: "multi-picker",
  props: {
    title: {
      type: String,
      require: true
    },
    icon: {
      type: String,
      require: true
    },
    children: {
      type: Array,
      required: true
    },
    isActive: {
      type: Function,
      default: () => false
    },
    active: {
      type: Boolean,
      default: true
    },
    closeOnClick: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      openState: false,
      preventTemper: null
    };
  },
  methods: {
    handleClickChild (item) {
      if (this.closeOnClick) this.openState = false;
      this.$emit('click-child', item);
    },
    handleClick () {
      if (this.preventTemper) return;
      this.openState = !this.openState;
    },
    handleMouseEnter () {
      this.openState = true;
      this.preventNext();
    },
    preventNext () {
      if (this.preventTemper) {
        clearTimeout(this.preventTemper);
      }
      this.preventTemper = setTimeout(() => {
        this.preventTemper = null;
      }, 300);
    },
    handleMouseLeave () {
      this.$nextTick(() => {
        this.openState = false;
      })
    }
  }
}
</script>

<style scoped>
.noDesc {
  margin: auto !important;
}

.fields.disabled {
  opacity: .5;
  cursor: not-allowed;
}

.field-dropdown {
  background: white;
  box-shadow: 0 0 8px 1px rgba(0, 0, 0, 0.12);
  padding: 20px 10px;
  display: grid;
  z-index: 9;
  position: absolute;
  max-height: 200px;
  overflow-y: auto;
  width: auto !important;
  font-family: Sofia Pro, sans-serif;
}

.field-dropdown:not(.open) {
  display: none;
}

.list-item {
  position: relative;
  display: grid;
  margin: 0 -10px;
  padding: 5px 10px;
  grid-gap: 10px;
  grid-template-columns: 14px auto;
  align-items: center;
  height: 20px;
  cursor: pointer;
}

.list-item:hover {
  background: rgba(0, 0, 0, 0.1);
}

.check-button {
  border: 1px solid black;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  position: relative;
}

.list-item:not(.active):hover .check-button::after {
  content: '';
  position: absolute;
  width: 6px;
  height: 6px;
  background: var(--orange);
  opacity: .4;
  left: 2px;
  top: 2px;
  border-radius: 3px;
}

.list-item.active .check-button::after {
  content: '';
  position: absolute;
  width: 6px;
  height: 6px;
  background: var(--orange);
  left: 2px;
  top: 2px;
  border-radius: 3px;
}

.list-item span {
  font-size: .9em;
  margin-bottom: -3px;
}
</style>



// WEBPACK FOOTER //
// src/pages/search/parts/multi-picker.vue